import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IPlacementMarginFurnitureAdjustmentsError,
  IPlacementMarginPeopleSoftCalculationResult,
  IPlacementMarginRequestTimeOff,
  ITreeLookupCategories,
} from './placement-assignment.model';
import { ITypeAheadOption } from '@AMIEWEB/Candidate/CandidateProfile/CandidateTabPanel/PreferencesTab/CustomComponents/ControlledTypeAhead';
import { IPlacementMarginToolAssignment } from './placement-assignment.model';
import {
  IPlacementMarginFurnitureCost,
  IPlacementMarginDetailsResponseScenario,
} from '../placement-add-edit-scenario/add-edit-placement-scenario.model';
import { IAssignmentForm } from '@AMIEWEB/MarginTool/Components/Assignments/models/IAssignmentSplitForm';
import { IMarginToolSave } from '@AMIEWEB/MarginTool/IMarginToolSave';

export const initialState: IPlacementMarginToolAssignment = {
  treeViewData: [],
  insuranceStatus: [],
  furnitureAdjustments: [],
  furnitureAdjustmentsError: [],
  editTimeOffs: [],
  editTimeOffGridError: false,
  peopleSoftResults: null,
  initialScenarioMarginDetails: null,
};

const getPlacementMarginTreeViewDataForPickList = createAction<{ placementId: number }>(
  'GET_PLACEMENT_MARGIN_TREE_VIEW_DATA_FOR_PICK_LIST',
);
const getPlacementMarginPickListDetails = createAction('GET_PLACEMENT_MARGIN_PICKLIST_DETAILS');
const triggerPlacementMarginPeopleSoftCalculation = createAction<{
  formData: IAssignmentForm;
  isDataUpdateFlow?: boolean | false | null;
  formDataRaw?: IMarginToolSave | null | undefined;
}>('TRIGGER_PLACEMENT_MARGIN_PEOPLE_SOFT_CALCULATION');
const getInitialPlacementMarginToolsData = createAction('GET_INITIAL_PLACEMENT_MARGIN_TOOLS_DATA');

const placementMarginAssignmentSlice = createSlice({
  name: 'placementMarginAssignment',
  initialState,
  reducers: {
    setTreeViewDataLookup: (state, action: PayloadAction<ITreeLookupCategories[]>) => {
      state.treeViewData = action.payload;
    },
    setInsuranceStatus(state, action: PayloadAction<ITypeAheadOption[]>) {
      state.insuranceStatus = action.payload;
    },
    setFurnitureAdjustments(state, action: PayloadAction<IPlacementMarginFurnitureCost[]>) {
      state.furnitureAdjustments = action.payload;
    },
    setFurnitureEditError(state, action: PayloadAction<IPlacementMarginFurnitureAdjustmentsError[]>) {
      state.furnitureAdjustmentsError = action.payload;
    },
    setEditTimeOffs(state, action: PayloadAction<IPlacementMarginRequestTimeOff[]>) {
      state.editTimeOffs = action.payload;
    },
    setEditTimeOffGridError(state, action: PayloadAction<boolean>) {
      state.editTimeOffGridError = action.payload;
    },
    setPeopleSoftResults(state, action: PayloadAction<IPlacementMarginPeopleSoftCalculationResult>) {
      state.peopleSoftResults = action.payload;
    },
    setInitialMarginDetailResponse(state, action: PayloadAction<IPlacementMarginDetailsResponseScenario>) {
      state.initialScenarioMarginDetails = action.payload;
    },
    reset() {
      return {
        ...initialState,
      };
    },
  },
});

const { actions } = placementMarginAssignmentSlice;

export const { name: placementMarginAssignmentSliceKey, reducer: placementMarginAssignmentReducer } =
  placementMarginAssignmentSlice;

export const placementMarginAssignmentActions = {
  ...actions,
  getPlacementMarginTreeViewDataForPickList: getPlacementMarginTreeViewDataForPickList,
  getPlacementMarginPickListDetails: getPlacementMarginPickListDetails,
  triggerPlacementMarginPeopleSoftCalculation: triggerPlacementMarginPeopleSoftCalculation,
  getInitialPlacementMarginToolsData: getInitialPlacementMarginToolsData,
};
